import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';

Vue.use(Vuex);

var home = {
  state: {
    homeAllList:{},
    guessLikeList: [],
    flashInfo: {
      prodList: [],
      time: 0,
      showList:[[],[]],
      hrefUrl: ''
    },
    topFixedMap:{},
    pageId: '90005',
    prodCategoryId: '',
    userCooQuery: {
      status: false,
      isEmp: false
    },
    resetGoldAreaTime: false,
    searchText: '',
    publicToastRecord: 1,
    publicToast: {
      show: false,
      type: 'addShopcart',
      text: '添加成功，在购物车等亲~'
    },
    scrollEndStatus: true,
    showNewCustom: false,
    topBgImg: '',
    contentBgImg: {},
    flushCache: clientTools.getQueryString('flushCaches') || '',
    labelStyle: ''
  },
  mutations: {
    setScrollEndStatus(state, val) {
      state.scrollEndStatus = val
    },
    setShowNewCustom(state, val) {
      state.showNewCustom = val
    },
    setGuessLikeList(state, val) {
      state.guessLikeList = val
    },
    setPageId(state, val) {
      state.pageId = val
    },
    setProdCategoryId(state, val) {
      state.prodCategoryId = val
    },
    setPublicToast(state, obj) {
      state.publicToast = obj
      setTimeout(() => {
        state.publicToastRecord ++
      }, 100);
      
    },
    doTrack(state, obj) {
      var idTypeObj = {
        'btnId': obj.adId, 'btnName': obj.adName
      }
      var relIdObj = {
        'relId1': state.pageId, 'relId2': obj.columnDefineId, 'relId3': obj.ccId
      }
      if(obj.idType && obj.idType == 'adId'){
        idTypeObj = {
          'adId': obj.adId, 'adName': obj.adName
        }
      }
      if(obj.idType && obj.idType == 'guessProdId'){
        idTypeObj = {
          'prodId': obj.adId, 'prodName': obj.adName
        }
        relIdObj.relId2 = 'index_qrqm'
        relIdObj.relId3 = obj.index
        relIdObj.relId4 = obj.relId4
        relIdObj.relId5 = obj.relId5
      }
      if(obj.idType && obj.idType == 'prodId'){
        idTypeObj = {
          'prodId': obj.adId, 'prodName': obj.adName
        }
      }
      if(obj.idType && obj.idType == 'tabId'){
        idTypeObj = {
          'tabId': obj.adId, 'tabName': obj.adName
        }
      }
      clickTrack(obj.href,relIdObj, idTypeObj)
      console.log(obj.href,relIdObj, idTypeObj)
    },
  },
  actions: {
    getAjaxBase: function (ctx, params) {
      if(home.state.homeAllList && home.state.homeAllList[params.pageId] && home.state.homeAllList[params.pageId].length){
        var guessLikeIndex = home.state.homeAllList[params.pageId].findIndex(o=>o.columnDefineId == "CD00000022")
        if(guessLikeIndex > -1){
          home.state.homeAllList[params.pageId][guessLikeIndex].adPositionList = JSON.parse(JSON.stringify(home.state.homeAllList[params.pageId][guessLikeIndex].adPositionListRecord))
        }
        return
      }
      home.state.homeAllList[params.pageId] = []
      var tempHomeList = []
      params.st = 2;
      home.state.flushCache && (params.flushCache = home.state.flushCache);
      axios.get('/secondchannel/ajax.jhtml',{ params: params }).then(function (res) {
        res.data.labelStyle && !home.state.labelStyle && (home.state.labelStyle = res.data.labelStyle);
        res.data.columnInfoList && res.data.columnInfoList.length > 0 && res.data.columnInfoList.forEach(item => {
          console.log(item.column.columnDefineId)
          var tempObj = {};
          item.column && item.column.columnDefineId && (tempObj.columnDefineId = item.column.columnDefineId);

          // item.column.margin = '30_60'
          // item.column.bgImg = 'http://image.buy.ccb.com/merchant/201711/5409599/1686641574103_3.png'
          // item.column.bgImg1920x1080 = 'http://image1.buy.ccb.com/images/000000/1686728695705.png'
          // item.column.bgImg1920x1080 = 'http://image.buy.ccb.com/merchant/201711/5409599/1686641574103_3.png'

          if(item.column.margin && item.column.margin.indexOf('_') > -1){
            var marginTop = item.column.margin.split('_')[0] || 0
            var marginBottom = item.column.margin.split('_')[1] || 0
            tempObj.marginObj = {
              top: (marginTop/3.75).toFixed(6) + 'vw',
              bottom: (marginBottom/3.75).toFixed(6) + 'vw',
            }
          }
          if(item.column.bgImg){
            tempObj.bgImg = item.column.bgImg
          }
          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000042' && item.adList && item.adList.length>0 && item.adList[0].imgUrl){
            tempObj.adList = item.adList[0]
            tempObj.imgUrl = item.adList[0].imgUrl
            tempObj.adHrefUrl = item.adList[0].adHrefUrl
            tempObj.adName = item.adList[0].adName
          }
          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000001' && !home.state.topFixedMap[tempObj.columnDefineId]){
            tempObj.logoImg = item.column.columnImg || ''
            tempObj.adList = item.adList || []
            // tempObj.searchText = item.column.columnName || ''
            // tempObj.searchHref = '/client/search.jhtml?hotKey=' + tempObj.searchText
            tempObj.searchHref = '/client/search.jhtml?templateId=indexPageNew&hotKey='
            if(item.column.margin && item.column.margin.indexOf('_') > -1){
              var marginTop = item.column.margin.split('_')[0] || 0
              var marginBottom = item.column.margin.split('_')[1] || 0
            }
            item.column.bgImg2400x1080 && (item.column.bgImg2408x1080 = item.column.bgImg2400x1080);
            var screenHeight = parseInt(window.screen.height*window.devicePixelRatio)
            var screenWidth = parseInt(window.screen.width*window.devicePixelRatio)
            var tempBgImg = ''
            screenHeight && screenWidth && item.column['bgImg'+screenHeight+'x'+screenWidth] && (tempBgImg = item.column['bgImg'+screenHeight+'x'+screenWidth]);
            !tempBgImg && item.column.bgImg && (tempBgImg = item.column.bgImg);
            home.state.topBgImg = tempBgImg
            home.state.topFixedMap[tempObj.columnDefineId] = tempObj
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000063'){
            item.column.bgImg2400x1080 && (item.column.bgImg2408x1080 = item.column.bgImg2400x1080);
            var screenHeight = parseInt(window.screen.height*window.devicePixelRatio)
            var screenWidth = parseInt(window.screen.width*window.devicePixelRatio)
            var tempBgImg = ''
            screenHeight && screenWidth && item.column['bgImg'+screenHeight+'x'+screenWidth] && (tempBgImg = item.column['bgImg'+screenHeight+'x'+screenWidth]);
            !tempBgImg && item.column.bgImg && (tempBgImg = item.column.bgImg);
            home.state.contentBgImg = Object.assign({}, home.state.contentBgImg, {
              [home.state.pageId]: tempBgImg
            })
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000050' && !home.state.topFixedMap[tempObj.columnDefineId]){
            tempObj.catList = item.catList || []
            home.state.topFixedMap[tempObj.columnDefineId] = tempObj
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000025'){
            tempObj.adList = {}
            tempObj.prodList = []
            item.adList && item.adList.length && (tempObj.adList = item.adList[0]);
            var discountPrice = item.column.discountPrice || ''
            if(item.prodList && item.prodList.length && item.prodList[0] && item.prodList[0].length){
              item.prodList[0].forEach(prod=>{
                var cutPrice = 0
                if(prod.prodPrice && prod.prodPrice.length>1){
                  // prod.prodPrice = prod.prodPrice.slice(1)
                  prod.prodPrice = prod.prodPrice.replace('¥','')
                }
                var prodTag = prod.prodTag.filter(o=>o.indexOf('满') > -1 && o.indexOf('减') > -1)
                if(prodTag.length){
                  var tempProdTag = []
                  prodTag.forEach(o=>{
                    var text2 = ''
                    var text1 = o.split('满')
                    text1.length > 1 && text1[1] && text1[1].indexOf('减') > -1 && (text2 = text1[1].split('减'));
                    if(text2 && text2.length > 1 && text2[0] && text2[1]){
                      tempProdTag.push({'cutPrice':text2[1],'limitPrice':text2[0]})
                    }
                  })
                  tempProdTag.length && tempProdTag.sort(sortMaxToMin)
                  tempProdTag.forEach(o=>{
                    if(cutPrice){return}
                    Number(prod.prodPrice) >= Number(o.limitPrice) && (cutPrice = Number(o.cutPrice))
                  })
                }
                discountPrice && (cutPrice = cutPrice + Number(discountPrice))
                if(cutPrice){
                  var prodPrice = ((Number(prod.prodPrice) - Number(cutPrice))*100).toFixed(2)/100
                  prodPrice < 0 && (prodPrice = 0);
                  prod.prodPrice = prodPrice
                }
                tempObj.prodList.push(prod)
              })
            }
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000024'){
            //注释
            // item.adGroup[3][0].alwaysShow = 1
            //注释
            tempObj.bgImg = item.column.columnImg || ''
            var tempAdGroup = item.adGroup.filter(o=>
              o && o.length > 0 && o[0].imgUrl
            )
            if(!clientTools.getCookie('ccb-main')){
              tempAdGroup = tempAdGroup.filter((o,catListIndex)=>!(o && o.length > 0 && o[0] && (item.catList[catListIndex].alwaysShow==2 || item.catList[catListIndex].alwaysShow==1)))
            }else if(!home.state.userCooQuery.status || !home.state.userCooQuery.isEmp){
              tempObj.needResetList = !home.state.userCooQuery.status
              tempObj.item = JSON.parse(JSON.stringify(item))
              tempAdGroup = tempAdGroup.filter((o,catListIndex)=>!(o && o.length > 0 && o[0] && item.catList[catListIndex].alwaysShow==1))
            }
            
            var resultObj = formatGoldArea(tempAdGroup,item)
            tempObj.goldList = resultObj.goldList
            tempObj.gifTime = resultObj.gifTime
            tempObj.gifRecordList = resultObj.gifRecordList

          };

          if(tempObj.columnDefineId && (tempObj.columnDefineId == 'CD00000015' || tempObj.columnDefineId == 'CD00000016')){
            tempObj.adList = item.adList || []
            tempObj.autoplay = item.column.intervalTime ? Number(item.column.intervalTime)*1000 : 3000
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000010'){
            tempObj.flashInfo = {
              prodList: [],
              time: 0,
              downTime: 0,
              showList:[[],[]],
              hrefUrl: ''
            }
            item.column && item.column.hrefUrl && (tempObj.flashInfo.hrefUrl = item.column.hrefUrl);
            tempObj.flashInfo.trackInfo = item.column
            ctx.dispatch('getFlashInfo',{homeListIndex: tempHomeList.length, classifyId: params.pageId, param: {num: 1,pageno: 1,ccid:home.state.prodCategoryId}})
            // item.column && item.column.hrefUrl && (home.state.flashInfo.hrefUrl = item.column.hrefUrl);
            // home.state.flashInfo.trackInfo = item.column
            // ctx.dispatch('getFlashInfo',{num: 1,pageno: 1})
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000017'){
            tempObj.catList = (item.catList.length > 4 ? item.catList.slice(0,4) : item.catList) || []
            tempObj.catList.forEach((fourGrids,fourGridsIndex) => {
              tempObj.catList[fourGridsIndex].prodList = []
              ctx.dispatch('getFourGridsProd',{columnId: fourGrids.extColumnId, fourGridsIndex: fourGridsIndex, homeListIndex: tempHomeList.length, classifyId: params.pageId})
            });
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000003' && item.templateNo && item.templateNo == 'AD_1_5_0'){
            tempObj.templateNo = item.templateNo
            tempObj.classifyList = []
            if(item.adList && item.adList.length > 0){
              tempObj.classifyList = item.adList.length > 5 ? item.adList.slice(0,5) : item.adList
              // tempObj.classifyAll = item.adList.length > 4 ? [item.adList[4]] : []
            }
            // else{
            //   tempObj.classifyAll = []
            //   tempObj.classifyList = []
            // }
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000020'){
            var tempAdList = []
            item.adList && item.adList.length && (tempAdList = item.adList)
            tempAdList.length > 8 && (tempAdList = tempAdList.slice(0,8));
            tempObj.adList = tempAdList
            tempObj.title = {
              name: item.column.columnName || '品牌精选',
              desc: item.column.columnDesc || '进入品牌馆',
              hrefUrl: item.column.columnUrl || '',
              columnId: item.column.columnId || ''
            }
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000003' && item.templateNo && item.templateNo == 'MIX_07_0'){
            tempObj.templateNo = item.templateNo
            tempObj.adList = item.adList || []
            var tempProdList = []
            item.prodList && item.prodList.length && item.prodList[0] && item.prodList[0].length && (tempProdList = item.prodList[0]);
            tempProdList.length > 4 && (tempProdList = tempProdList.slice(0,4))
            tempProdList.forEach((tempProdItem,tempProdIndex) => {
              tempProdItem.prodPrice && tempProdItem.prodPrice.length > 0 && (tempProdList[tempProdIndex].prodPrice = tempProdItem.prodPrice.replace('¥',''))
            });
            tempObj.autoplay = 3000
            tempObj.prodList = tempProdList
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000003' && item.templateNo && item.templateNo == 'PR_1_1_3'){
            tempObj.templateNo = item.templateNo
            var tempProdList = []
            item.prodList && item.prodList.length && item.prodList[0] && item.prodList[0].length && (tempProdList = item.prodList[0]);
            tempProdList.forEach((tempProdItem,tempProdIndex) => {
              tempProdItem.prodPrice && tempProdItem.prodPrice.length > 0 && (tempProdList[tempProdIndex].prodPrice = tempProdItem.prodPrice.replace('¥',''))
            });
            tempObj.prodList = tempProdList
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000023'){
            tempObj.adList = item.adList || []
            tempObj.styleObj = {
              bgColor: '#fef8b5',
              textColor: '#56534b'
            }
            item.column && item.column.bgColor && (tempObj.styleObj.bgColor = item.column.bgColor);
            item.column && item.column.textColor && (tempObj.styleObj.textColor = item.column.textColor);
          };

          if(tempObj.columnDefineId && tempObj.columnDefineId == 'CD00000022'){
            var adPosition = item.column.adPosition || 5;
            // item.adList = [
            //   {imgUrl:'http://image.buy.ccb.com/images/000000/1686206336606.png',adDesc: "8"},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/5445524/1654136335051_4.jpg',adDesc: ""},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/5445524/1685950356306_4.JPG',adDesc: ""},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/5445524/1685950372517_4.png',adDesc: "22"},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/5490708/1616391423041_3.jpg',adDesc: ""},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/000000/1611544784634.jpg',adDesc: "0"},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/000000/1654488082234.png',adDesc: ""},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/000000/1654488020139.png',adDesc: "16"},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/MA00000002/1654504083773.png',adDesc: ""},
            //   {imgUrl:'http://image.buy.shanrongmall.com/images/MA00000002/1654504068591.png',adDesc: "4"}
            // ]
            if(item.adList && item.adList.length > 0){
              tempObj.adPositionList = formatGuessAdList(item.adList, Number(adPosition))
            }else{
              tempObj.adPositionList = []
            }
            tempObj.adPositionListRecord = JSON.parse(JSON.stringify(tempObj.adPositionList))
          };          

          tempObj.columnDefineId && tempHomeList.push(tempObj);
        });
        home.state.homeAllList = Object.assign({}, home.state.homeAllList, {
          [params.pageId]: tempHomeList
        })
        // home.state.homeAllList[params.pageId] = tempHomeList
        console.log(home.state.homeAllList)
      })
    },
    getFourGridsProd: function (ctx, params) {
      axios.get('/secondchannel/api_prodList.jhtml?level=2&pageno=1&pagesize=4',{ params: {columnId: params.columnId} }).then(function (res) {
        if(res.data.prodList && res.data.prodList.length > 0){
          home.state.homeAllList[params.classifyId][params.homeListIndex].catList[params.fourGridsIndex].prodList = res.data.prodList.length > 2 ? res.data.prodList.slice(0,2) : res.data.prodList
        }
      })
    },
    getFlashInfo: function (ctx, params) {
      axios.get('/client/ajaxFlashSaleProd.jhtml',{ params: params.param }).then(function (res) {
        res.data.prodList && res.data.prodList.length < 4 && (res.data.prodList = []); 
        if(res.data.prodList && res.data.prodList.length > 0){
          home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.prodList = res.data.prodList;
          if(home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.prodList.length >= 8){
            home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.showList[0] = home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.prodList.slice(0,4)
            home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.showList[1] = home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.prodList.slice(4,8)
          }else{
            var index = home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.prodList.length > 4 ? 4 : home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.prodList.length
            home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.showList[0] = home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.prodList.slice(0,index)
          }
          // formatFlashProdList()
        }
        res.data.promotionList && res.data.promotionList.length > 0 && ctx.dispatch('getFlashTime',{homeListIndex: params.homeListIndex, classifyId: params.classifyId,param:{startTime:res.data.promotionList[0].start,endTime:res.data.promotionList[0].end}});
        // this.getFlashTimer(res.promotionList[0].start,res.promotionList[0].end,index)
      })
    },
    getFlashTime: function (ctx, params) {
      axios.get('/InvokeServlet?methodName=GetLeftTime',{ params: params.param }).then(function (res) {
        if (res.data.result > 0 && res.data.sTime == 0) {
					home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.time = res.data.result * 1000
				}else if(res.data.result > 0 && res.data.sTime > 0){
					home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.time = res.data.sTime * 1000
        }
        home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.downTime = Number(home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.time)
        flashDownTime({classifyId: params.classifyId,homeListIndex: params.homeListIndex})
      })
    },
    userInfoQuery: function(ctx, params){
      axios.post('/member/userInfoQuery.jhtml').then(function (res) {
        res.data && res.data.result && res.data.result == '0' && res.data.isNewCust && res.data.isNewCust == '1' && (home.state.showNewCustom = true);
        if(res.data && res.data.isEmp && res.data.isEmp == '1'){
          home.state.userCooQuery.isEmp = true
          resetGoldArea()
        }
        home.state.userCooQuery.status = true;
      })
    },
    getUserCooQuery: function (ctx, params) {
      axios.get('/member/member/userCooQuery.jhtml',{ params: params }).then(function (res) {
        //注释
        // res.data.isEmp = '0'
        // setTimeout(() => {
        //   if(res.data && res.data.isEmp && res.data.isEmp == '1'){
        //     home.state.userCooQuery.isEmp = true
        //     resetGoldArea()
        //   }
        //   home.state.userCooQuery.status = true;
        // }, 5000);
        // return
        //注释
        if(res.data && res.data.isEmp && res.data.isEmp == '1'){
          home.state.userCooQuery.isEmp = true
          resetGoldArea()
        }
        home.state.userCooQuery.status = true;
      })
    },
    getHotKeyList: function (ctx, params) {
      axios.get('/searchproducts/hotKeyList.jhtml',{ params: params }).then(function (res) {
        if(res.data && res.data.hotkeyList && res.data.hotkeyList.length > 0){
          var index = Math.floor(Math.random() * res.data.hotkeyList.length);
          index > res.data.hotkeyList.length - 1 && (index = res.data.hotkeyList.length - 1);
          index < 0 && (index = 0);
          home.state.searchText = res.data.hotkeyList[index].hotKey || ''
        }
      })
    },
  }
};

function flashDownTime(params) {
  setTimeout(() => {
    home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.downTime = home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.downTime - 1000  
    if(home.state.homeAllList[params.classifyId][params.homeListIndex].flashInfo.downTime >= 1000){
      flashDownTime({classifyId: params.classifyId,homeListIndex: params.homeListIndex})
    }
  }, 1000);
}
function formatGoldArea(tempAdGroup,item){
  var resultObj = {}
  var topList = []
  var bottomList = []
  tempAdGroup && tempAdGroup.forEach((o,index) => {
    var tempObj = {
      adHrefUrl: '',
      adName: '',
      imgUrl: '',
      gifUrl: ''
    }
    if(o && o.length > 0 && o[0]){
      tempObj = o[0]
      tempObj.adHrefUrl = o[0].adHrefUrl || ''
      tempObj.adName = o[0].adName || ''
      tempObj.imgUrl = o[0].imgUrl || ''
    }
    if(o.length >= 2 && o[1]){
      tempObj.gifUrl =  o[1].imgUrl || ''
    }
    if(index % 2 == 1){
      bottomList.push(tempObj)
    }else{
      topList.push(tempObj)
    }
  });
  var gifRecordList = []
  topList.forEach((topListItem,topListIndex) => {
    if(topListItem.gifUrl){
      gifRecordList.push({
        colIndex: 0,
        rowIndex: topListIndex,
      })
    }
  });
  bottomList.forEach((bottomListItem,bottomListIndex) => {
    if(bottomListItem.gifUrl){
      gifRecordList.push({
        colIndex: 1,
        rowIndex: bottomListIndex,
      })
    }
  });

  resultObj.goldList = [topList,bottomList]
  resultObj.gifTime = item.column.intervalTime ? Number(item.column.intervalTime)*1000 : 3000
  resultObj.gifRecordList = gifRecordList
  return JSON.parse(JSON.stringify(resultObj))
}
function resetGoldArea(){
  for(var key in home.state.homeAllList){
    home.state.homeAllList[key].forEach((o,index)=>{
      if(o.columnDefineId == "CD00000024" && o.needResetList && o.item && o.item.adGroup && o.item.adGroup.length){
        var resultObj = formatGoldArea(o.item.adGroup,o.item)
        home.state.homeAllList[key][index].goldList = resultObj.goldList
        home.state.homeAllList[key][index].gifRecordList = resultObj.gifRecordList
        home.state.resetGoldAreaTime = true
      }
    })
  }
}
function formatFlashProdList(){
  if(home.state.flashInfo.prodList.length < 8){
    home.state.flashInfo.prodList = [...home.state.flashInfo.prodList, ...home.state.flashInfo.prodList]
    formatFlashProdList()
  }else{
    home.state.flashInfo.prodList = home.state.flashInfo.prodList.slice(0,8)
    home.state.flashInfo.showList[0] = home.state.flashInfo.prodList.slice(0,4)
    home.state.flashInfo.showList[1] = home.state.flashInfo.prodList.slice(4,8)
  }
}
function formatGuessAdList(list, num){
  list.forEach((o,index) => {
    list[index].adPositionType = true
    var tempHtml = `<img style="display: none;width: 168px" src="` + o.imgUrl + `" alt="" />`
    $('body').append(tempHtml)
  });
  var adPositionList = list.filter(o=>o.adDesc);
  var adCircleList = list.filter(o=>!o.adDesc)
  adPositionList.length>0 && (adPositionList = adPositionList.sort(sortMinToMax));
  var adDescIndex = 0
  adPositionList.forEach((o,index) => {
    adPositionList[index].adPositionIndex = Number(o.adDesc)
    adDescIndex = Number(o.adDesc)
  });
  adCircleList.forEach((o,index) => {
    adCircleList[index].adPositionIndex = adDescIndex + num
    adDescIndex += num
  });
  return JSON.parse(JSON.stringify(adPositionList.concat(adCircleList)))
}
function sortMinToMax(a, b) {
  return Number(a.adDesc) - Number(b.adDesc)
}
function sortMaxToMin(a, b) {
  return Number(b.cutPrice) - Number(a.cutPrice)
}
export default new Vuex.Store({
  modules: {
    home,
  }
})


